import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import Text from '../Text'

const DatedListItemCard = ({
  date,
  footerInfo,
  secondaryContent,
  children,
  onClick
}) => {
  const dateFormatted = new Date(date)
  const month = dateFormatted.toLocaleString('default', { month: 'short' })
  const day = dateFormatted.toLocaleString('default', { day: 'numeric' })
  return (
    <article
      className={classnames(
        'vs-dated-list-item-card',
        {'vs-dated-list-item-card--tappable': !!onClick}
      )}
      onClick={onClick}
    >
      <section className='vs-dated-list-item-card__wrapper'>
        <div className='vs-dated-list-item-card__date-wrapper'>
          <Text className='vs-dated-list-item-card__date' size='large' bold>{day}</Text>
          <Text className='vs-dated-list-item-card__date' size='xsmall' uppercase bold>{month}</Text>
        </div>

        <div className='vs-dated-list-item-card__main-content'>
          {children}
        </div>
      </section>
      {secondaryContent && (
        <section>
          {secondaryContent}
        </section>
      )}

      {!secondaryContent && footerInfo && (
        <footer className='vs-dated-list-item-card__footer'>
          <Text size='tiny' italic>
            {footerInfo}
          </Text>
        </footer>
      )}

    </article>
  )
}

DatedListItemCard.propTypes = {
  /**
    * Whatever you want to show inside of the card
  */
  children: PropTypes.node.isRequired,
  /**
   * A date to display on the left. Any format that new Date(date) will swallow
   */
  date: PropTypes.string.isRequired,
  /**
   * Information to show under main content
   */
  footerInfo: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string
  ]),
  /**
   * If you want to make the card clickable, you can pass the onClick event
   */
  onClick: PropTypes.func
}

DatedListItemCard.defaultProps = {
  date: new Date()
}

export default DatedListItemCard
